export const MODULE_NAME = 'matomoModule';
